import $api from "@/core/services/ApiService";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import { PurchaseProduct } from "@/core/services/api/interfaces/guest/Product";

class ProductEndpoint {
  public viewGuest(hash: string): Promise<AxiosResponse> {
    return $api.get(`products/${hash}`);
  }

  public getWalletForProduct(
    hash: string,
    data: PurchaseProduct
  ): Promise<AxiosResponse> {
    return $api.post(`products/${hash}/wallet`, data as AxiosRequestConfig);
  }
}

export default ProductEndpoint;
